import {MoveDrawer} from '../../../../../mode/MoveDrawer';
import {Point} from '@app/modules/svg/model/Point';
import {MoveDrawable} from '../../../../../type/MoveDrawable';
import {SVGEvent} from '@app/modules/svg/dataSource/constant/SVGEvent';
import {ElementType} from '@app/modules/svg/dataSource/constant/ElementType';
import {ParallelogramView} from '@app/modules/svg/element/shape/pointed/polygon/parallelogram/ParallelogramView';
import {Rect} from '@app/modules/svg/model/Rect';

export class DrawParallelogram extends MoveDrawer {
  protected createDrawableElement(position: Point): MoveDrawable {
    return new ParallelogramView(this.drawTool.container, {overEvent: true, globalStyle: true, rightShapeAngle: ParallelogramView.DEFAULT_RIGHT_SHAPE_ANGLE}, {x: position.x, y: position.y, width: 0, height: 0});
  }

  public override makeMouseMove(position: Point, call: boolean = true, parameter?: any): void {
    let width: number = position.x - this.startPosition.x;
    let height: number = position.y - this.startPosition.y;

    if (this.drawTool.perfect || this._drawableElement.proportionalResizable) {
      const averageSize: number = (Math.abs(width) + Math.abs(height)) / 2;
      if (width < 0) {
        width = -averageSize * 2;
      } else {
        width = averageSize * 2;
      }
      if (height < 0) {
        height = -averageSize / 2;
      } else {
        height = averageSize / 2;
      }
    }

    if (this.drawTool.container.grid.isSnapOn()) {
      const snapPoint: Point = this.drawTool.container.grid.getSnapPoint({
        x: this.startPosition.x + width,
        y: this.startPosition.y + height
      });
      width = snapPoint.x - this.startPosition.x;
      height = snapPoint.y - this.startPosition.y;
    }

    const rect: Rect = {
      x: this.startPosition.x,
      y: this.startPosition.y,
      width,
      height
    };
    if (this.drawTool.mirroring) {
      rect.x -= width;
      rect.y -= height;

      rect.width *= 2;
      rect.height *= 2;
    }

    /* if _drawableElement instance of MoveDrawable, set drawSize */
    (this._drawableElement as unknown as MoveDrawable).__drawSize__(rect);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.DRAW_MOUSE_MOVE, {position, element: this._drawableElement});
    }
  }

  public override start(call: boolean = true): void {
    super.start(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.PARALLELOGRAM_TOOL_ON);
    }
  }
  public override stop(call: boolean = true): void {
    super.stop(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.PARALLELOGRAM_TOOL_OFF);
    }
  }

  public _new(): DrawParallelogram {
    return new DrawParallelogram(this.drawTool);
  }
  public get type(): ElementType {
    return ElementType.PARALLELOGRAM;
  }
}
